module.exports = __webpack_public_path__ + "static/media/epp-mobile.bce0b0af.svg";